<template>
  <header
    class="py-2 border-bottom border-gray-9 mb-2"
    :class="{ 'd-flex align-items-center justify-content-between': btn }"
  >
    <h2 class="text-18 text-md-20 fw-600 text-gray-2">{{ title }}</h2>
    <div class="ml-auto" v-if="btn">
      <b-btn
        v-bind="btn.props"
        variant="platform-light py-1 px-3 text-12 fw-600"
        @click="$emit('btn-click', $event)"
      >
        {{ btn.text }}
      </b-btn>
    </div>
  </header>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: null,
    },
    btn: {
      type: Object,
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped></style>
